import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { TabsPage } from '../pages/tabs/tabs';
// import { LoginPage } from '../pages/login/login';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { SignupPage, TermsModel } from '../pages/signup/signup';
import { CustomvalidationProvider } from '../providers/customvalidation/customvalidation';
import { ApiProvider } from '../providers/api/api';
import { IonicSelectableModule } from 'ionic-selectable';
// import { LeadsPage } from '../pages/leads/leads';
import { IonicStepperModule } from 'ionic-stepper';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Camera } from '@ionic-native/camera';
// import { AgencyRequestPage } from '../pages/agency-request/agency-request';
// import { FranchiseRequestPage } from '../pages/franchise-request/franchise-request';
import { CookieService } from 'ngx-cookie-service';
// import { ChatRoomPage } from '../pages/chat-room/chat-room';
// import { ChatPage } from '../pages/chat/chat';
// // import { ChatRoomAddPage } from '../pages/chat-room-add/chat-room-add';
// import { AddLeadsModel, LeadsTabsPage, UseLeadsModel } from '../pages/leads-tabs/leads-tabs';
// import { ProfilePage, ScreenModel } from '../pages/profile/profile';
import { SocialSharing } from '@ionic-native/social-sharing';
// import { AddPoliciesModel, SearchPage } from '../pages/search/search';
import { AgmCoreModule } from '@agm/core';
// import { PaymentModel, SubscriptionPage } from '../pages/subscription/subscription';
// import { ChaptersPage } from '../pages/chapters/chapters';
// import { MapsPage } from '../pages/maps/maps';
// import { VideoPage } from '../pages/video/video';
import { Screenshot } from '@ionic-native/screenshot';
import { FileOpener } from '@ionic-native/file-opener';
import { File } from '@ionic-native/file';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { QRCodeModule } from 'angular2-qrcode';
// import { StartLeadsPage } from '../pages/start-leads/start-leads';
// import { LeadsViewPage } from '../pages/leads-view/leads-view';
// import { FavouritePage } from '../pages/favourite/favourite';
// import { NotificationsPage } from '../pages/notifications/notifications';
// import { PurchasePage } from '../pages/purchase/purchase';
// import { BuyersPage } from '../pages/buyers/buyers';
// import { RfqBucketPage } from '../pages/rfq-bucket/rfq-bucket';
import { CommonModule, DatePipe } from '@angular/common';
// import { PakageviewDetailsPage } from '../pages/pakageview-details/pakageview-details';
// import { RfqPage } from '../pages/rfq/rfq';
// import { BuyerviewPage } from '../pages/buyerview/buyerview';
// import { TermsPage } from '../pages/terms/terms';
// import { HscrmPage } from '../pages/hscrm/hscrm';
import { Geolocation } from '@ionic-native/geolocation';
// import { ForgotpasswordPage } from '../pages/forgotpassword/forgotpassword';
// import { ChatGroupsPage } from '../pages/chat-groups/chat-groups';
// import { ChatChaptersPage } from '../pages/chat-chapters/chat-chapters';
import { OneSignal } from '@ionic-native/onesignal';
import { LeadsPageModule } from '../pages/leads/leads.module';
import { AddLeadsModel, UseLeadsModel } from '../pages/leads-tabs/leads-tabs';
import { PaymentModel } from '../pages/subscription/subscription';
import { AddPoliciesModel } from '../pages/search/search';
import { ScreenModel } from '../pages/profile/profile';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CertifyingagencyPage } from '../pages/certifyingagency/certifyingagency';
import { WindowProvider } from '../providers/window/window';
import { ApplePay } from '@ionic-native/apple-pay/ngx';
import { agentpaymentModal } from '../pages/agentsubscription/agentsubscription';
import { ServicePaymentModel } from '../pages/servicesubscription/servicesubscription';
// import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';
// import { InAppPurchase2 } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
// import { ApplePay } from '@ionic-native/apple-pay';
// import { NotificationchatPage } from '../pages/notificationchat/notificationchat';
// import { ToolkitPage  } from '../pages/toolkit/toolkit';
// import { DownloadPage  } from '../pages/download/download';


@NgModule({
  declarations: [

    MyApp,
    UseLeadsModel,
    AddLeadsModel,
    PaymentModel,
    AddPoliciesModel,
    ScreenModel,
    CertifyingagencyPage,
    agentpaymentModal,
    ServicePaymentModel
    // NotificationchatPage
  ],
  imports: [
    BrowserModule,
    CommonModule,
    IonicModule.forRoot(MyApp),
    FormsModule,
    NgxQRCodeModule,
    QRCodeModule,
    ReactiveFormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    IonicSelectableModule,
    IonicStepperModule,
    BrowserAnimationsModule,
    AgmCoreModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    UseLeadsModel,
    AddLeadsModel,
    PaymentModel,
    AddPoliciesModel,
    ScreenModel,
    CertifyingagencyPage,
    agentpaymentModal,
    ServicePaymentModel,
    // NotificationchatPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    CustomvalidationProvider,
    ApiProvider,
    Camera,
    Screenshot,
    FileOpener,
    OneSignal,
    // InAppPurchase,
    File,
    CookieService,
    TabsPage, InAppBrowser,
    ApplePay,
    SocialSharing,
    DatePipe, Geolocation,
    WindowProvider,
    // InAppPurchase2
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    IonicSelectableModule,
    IonicStepperModule,
    BrowserAnimationsModule,
    AgmCoreModule
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts